
import 'jquery-match-height';

export default {
  init() {
    // JavaScript to be fired on all pages
    let elements = document.querySelectorAll('[data-responsive-background-image], [data-responsive-large-background-image], [data-responsive-extralarge-background-image]');
    for (let i=0; i<elements.length; i++) {
      new ResponsiveBackgroundImage(elements[i]);
    }

    jQuery.fn.isInViewport = function(offsetVp) {
      var elementTop = jQuery(this).offset().top;
      var elementBottom = elementTop + jQuery(this).outerHeight();

      var viewportTop = jQuery(window).scrollTop() - offsetVp;
      var viewportBottom = viewportTop + jQuery(window).height() - offsetVp;

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    function is_touch_device() {
      try {
        document.createEvent("TouchEvent");
        return true;
      } catch (e) {
        return false;
      }
    }

    jQuery(window).on('resize scroll', function() {
      if (jQuery(document).scrollTop() > 50) {
        jQuery('body').addClass('shrink');
      } else {
        jQuery('body').removeClass('shrink');
      }
      jQuery('#collapsingNavbar').collapse('hide');
      jQuery('#navbarNavSingle').collapse('hide');
      if(is_touch_device()) {
        jQuery('figure h2').each(function() {
          var figThis = jQuery(this)
          if (jQuery(this).isInViewport(50)) {
            figThis.parents('figure.effect-sadie').addClass('active');
          } else {
            figThis.parents('figure.effect-sadie').removeClass('active');
          }
        });
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
export class ResponsiveBackgroundImage {
  constructor(element) {
      this.element = element;
      this.img = element.querySelector('img');
      this.src = '';

      if(this.img != null) {
        this.img.addEventListener('load', () => {
          this.update();
        });

        if (this.img.complete) {
            this.update();
        }
      }
  }

  update() {
      let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
      if (this.src !== src) {
          this.src = src;
          this.element.style.backgroundImage = 'url("' + this.src + '")';

      }
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js